
const assessmentsLibrary = [

    {
        name: "Cognitive Ability Assessments",
        data: [
            {
                heading: "Divided Attention",
                desc: "Divided attention refers to the ability to respond to different competing stimuli at the same time. It is the performance of multiple tasking."
            },
            {
                heading: "Inhibitory Control",
                desc: "Inhibitory control is the ability to control one’s emotion’s, focus, thoughts and behaviors. Some aspects of this might involve other forms of self-control such as delaying gratification or actively suppressing unwanted thoughts (cognitive inhibition)."
            },
            {
                heading: "Updating",
                desc: "Updating is the ability of the mind to execute behaviors and actions consistent with the delivery of a task according to a plan of action."
            },
            {
                heading: "Sustained Attention",
                desc: "Sustained attention is the ability to focus on an action or activity for long periods of time. It is a brain function that enables individuals to concentrate on a task or set of task and take them to completion without losing focus even when even if there are other distractions present. "
            },
            {
                heading: "Planning",
                desc: "Planning is a complex and fundamental cognitive function that forms part of our core executive functions that involves thinking ahead, evaluating options, and choosing the best course of action."
            },
            {
                heading: "Focused Attention",
                desc: "Focused attention is the ability to accurately and thoroughly direct attention to, and respond to a specific stimulus. The stimuli may be auditory, visual, tactile, or cognitive."
            },
            {
                heading: "Information Processing",
                desc: "Information processing speed refers to the speed with which information can be sensed, perceived, understood, and then responded to. It can be specified as a combination of visual perception and scanning ability, working speed, encoding of information, cognitive flexibility, attention as well as transformation and retrieval"
            },
            {
                heading: "Working Memory",
                desc: "Working memory is a data processing function in which the brain constantly captures, stores, manipulates and recalls information to make it readily available for individuals to take actions and make decisions. "
            },
            {
                heading: "Cognitive Flexibility",
                desc: "Cognitive flexibility is the capacity to alter between different tasks or goals which enables divergent thinking, changing perspectives and being able to quickly adapt to a new changing "
            },
        ],
    },
    {
        name: "Competency Assessments",
        data: [
            {
                heading: "Lorem, ipsum.",
                desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi aut iste, ipsa fugiat repudiandae est ad? Amet velit ullam libero?"
            },
            {
                heading: "Lorem, ipsum.",
                desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi aut iste, ipsa fugiat repudiandae est ad? Amet velit ullam libero?"
            },
            {
                heading: "Lorem, ipsum.",
                desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi aut iste, ipsa fugiat repudiandae est ad? Amet velit ullam libero?"
            },
            {
                heading: "Lorem, ipsum.",
                desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi aut iste, ipsa fugiat repudiandae est ad? Amet velit ullam libero?"
            },
            {
                heading: "Lorem, ipsum.",
                desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi aut iste, ipsa fugiat repudiandae est ad? Amet velit ullam libero?"
            },
            {
                heading: "Lorem, ipsum.",
                desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi aut iste, ipsa fugiat repudiandae est ad? Amet velit ullam libero?"
            },
        ],
        nestedAssessments: [
            {
                name: "Future Focused",
                data: [
                    {
                        heading: "External Orientation",
                        desc: "External orientation refers to the exposure and engagement with the external world such as customers or networks to drive business."
                    },
                    {
                        heading: "Imagination",
                        desc: "Imagination refers to the tendency to generate or recognize ideas or possibilities to produce new solutions to problems."
                    },
                    {
                        heading: "Strategic Thinking",
                        desc: "Strategic thinking is the ability to plan for the future and anticipate forthcoming challenges to be able to solve complex problems."
                    },
                    {
                        heading: "Innovation",
                        desc: "Innovation refers to the process of putting creative ideas into practice to create new value, processes, or products."
                    },
                ],

            },
            {
                name: "Getting Things Done",
                data: [
                    {
                        heading: "Customer Focused",
                        desc: "Customer focus refers to a strategy that puts the customers' needs first and aligns business processes with their expectations."
                    },

                    {
                        heading: "Planning",
                        desc: "Planning refers to the process of setting objectives, targets, and formulating a plan to accomplish them."
                    },
                    {
                        heading: "Entrepreneurship",
                        desc: "Entrepreneurship refers to the ability and enthusiasm to take risks to develop, organize and run a business enterprise. "
                    },
                    {
                        heading: "Drive for Results",
                        desc: "Drive for results refers to maintaining high levels of effectiveness and determination to deliver peak results/goals."
                    },
                ],

            },
            {
                name: "Working With Others",
                data: [
                    {
                        heading: "Collaboration",
                        desc: "Collaboration alludes to the ability of individuals to work together for a common purpose to achieve business benefit."
                    },
                    {
                        heading: "Effective Communication",
                        desc: "Effective Communication is the ability to listen attentively and convey information in an articulate, clear and concise manner."
                    },
                    {
                        heading: "Influence",
                        desc: "Influence refers to the ability to shape or transform others’ beliefs and actions to gain their support and drive positive results."
                    },
                    {
                        heading: "Valuing Diversity",
                        desc: "Valuing diversity refers to acknowledging the differences between people and using their differences as an asset."
                    },

                ],

            },
            {
                name: "Leading Others",
                data: [
                    {
                        heading: "Develop Others",
                        desc: "Develop others refers to constructively reviewing the work of others in order to improve and advance their skills, knowledge, and performance."
                    },
                    {
                        heading: "Recognition",
                        desc: "Recognition refers to the ability to create an environment where individuals are rewarded and praised for their contribution and talents."
                    },
                    {
                        heading: "Set Direction",
                        desc: "Set direction refers to the ability to set clear performance standards that you expect you team to meet and deliver them over time."
                    },
                    {
                        heading: "Delegation",
                        desc: "Delegation refers to empowering employees by giving them the decision making power or task responsibility to maximize the organization's and individual effectiveness."
                    },

                ],

            },
            {
                name: "Self Mastery",
                data: [
                    {
                        heading: "Agility",
                        desc: "Agility refers to navigating change in a dynamic and ambiguous environment while embracing game-altering opportunities resulting from those."
                    },
                    {
                        heading: "Character",
                        desc: "Character refers to the ability to display personal integrity and courage regardless of the possible adverse consequences. "
                    },
                    {
                        heading: "Perseverance",
                        desc: "Perseverance refers to the continuous effort to achieve results despite difficulties, or opposition and being ready to endure for the long haul."
                    },
                    {
                        heading: "Investing in Self",
                        desc: "Investing in self refers to the ability to take on new learnings, and therefore increase abilities, knowledge, and achievement."
                    },

                ],

            },
        ]
    },
    {
        name: "Aptitude Assessments",
        data: [
            {
                heading: "English Verbal Reasoning",
                desc: "The Verbal Reasoning assesses a person's ability to understand, analyze, and interpret written information."
            },
            {
                heading: "Numerical Logic",
                desc: "Numerical Logic assess logical thinking ability. They are designed to evaluate the degree to which you can think clearly and analytically to solve the problems."
            },
            {
                heading: "Basic Arithmetic",
                desc: "Basic Arithmetic are skills and knowledge of the most basic mathematics."
            },
            {
                heading: "Inductive Reasoning",
                desc: "Inductive reasoning is the ability to identify and interpret patterns. They have been found to have a high correlation with general intelligence and the ability to reason logically."
            },
        ],

    },
]
export default assessmentsLibrary